export enum SubApplicationTypes {
  LOC = 1,
  SCHEDULEA = 2,
  SCHEDULEB = 3,
  FINANCIALS = 4,
  UKD = 5,
  IA = 6,
  //CAL = 7,
  CONTACTS = 8,
  PRODUCTS = 9,
  ALL_FEATURES = 10,
}
